import { URLS } from '@/constants/urls';
import { getApiError, joinUrl, toFormData } from '@/utils';
import { PostFormResponse } from './post-form-data.types';
const baseURL = process.env.API_URL;

export const postFormData = function <Req extends object, Res>(url: URLS) {
  return async (
    data: Req,
    init?: RequestInit
  ): Promise<PostFormResponse<Res>> => {
    try {
      const response = await fetch(joinUrl(baseURL, url), {
        method: 'POST',
        body: toFormData(data as object),
        headers: {
          Accept: 'application/json', // Явно указываем ожидаемый ответ
        },
        ...init,
      });

      if (response.ok) {
        return {
          data: (await response.json()) as Res,
          error: undefined,
        };
      }

      return {
        error: 'UknownError',
        data: undefined,
      };
    } catch (error) {
      return {
        error: getApiError(error),
        data: undefined,
      };
    }
  };
};
